<template>
  <div class="snow">
    <Header></Header>
    <Breadcrumb v-if="this.$route.name !== 'home'"></Breadcrumb>

    <main class="wrapper">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <keep-alive max="5">
            <component :is="Component" :key="$route.fullPath" />
          </keep-alive>
        </transition>
      </router-view>
    </main>

    <Footer></Footer>

    <div
      class="scroll-top scrollTo"
      v-scroll-to="{ el: '#body', duration: 700, offset: 0 }"
      :class="{ active: scrollTop }"
    >
      top
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
// import snowf from "@/js/snowf";
const Footer = defineAsyncComponent(() => import("@/js/components/Footer.vue"));
const Header = defineAsyncComponent(() => import("@/js/components/Header.vue"));
const Breadcrumb = defineAsyncComponent(() =>
  import("@/js/components/Breadcrumb.vue")
);

export default {
  name: "App",
  components: {
    Footer,
    Header,
    Breadcrumb,
  },

  // setup() {
  //   const snow = snowf;

  //   return {
  //     snow,
  //   };
  // },

  data() {
    return {
      scrollTop: false,
    };
  },

  methods: {
    offsetY() {
      if (window.pageYOffset > document.documentElement.clientHeight) {
        this.scrollTop = true;
      } else {
        this.scrollTop = false;
      }
    },
  },

  mounted() {
    this.$nextTick(function () {
      window.addEventListener("scroll", this.offsetY);
      // this.snow.init({
      //   dom: ".snow",
      //   size: 7,
      //   amount: 200,
      //   zIndex: 999,
      //   swing: 2,
      // });
    });
  },

  beforeUnmount() {
    window.removeEventListener("scroll", this.offsetY);
  },

  watch: {
    $route() {
      if (this.$route.name === "home") {
        document.body.classList.add("home");
      } else {
        if (document.body.classList.contains("home")) {
          document.body.classList.remove("home");
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/sass/main";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.scroll-top {
  position: fixed;
  z-index: 80;
  @include property("right", 40, 15);
  @include property("bottom", 60, 30);
  @include property("width", 60, 40);
  @include property("height", 60, 40);
  font-size: 0;
  background: url("/images/svg/top.svg") center center / 160% 160% no-repeat;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transition: all 0.4s ease-out;

  &.active {
    opacity: 1;
    visibility: visible;
  }
}
</style>